import CategoryList from './category-list';

export default CategoryList;
